// src/components/dashboard/cases/newCase/case_id/caseTable/components/OpacityPanel.js
import React from "react";
import { OPACITY_MIN, OPACITY_MAX } from "../constants";

const OpacityPanel = ({ opacity, setOpacity }) => {
  const opacityFill = `${
    ((opacity - OPACITY_MIN) / (OPACITY_MAX - OPACITY_MIN)) * 100
  }%`;

  return (
    <div
      className="stl-opacity-panel stl-opacity-fixed"
      role="group"
      aria-label="Model opacity"
    >
      <div className="stl-opacity-header">
        <span className="stl-opacity-title">Opacity</span>
        <span className="stl-opacity-value">{opacity}%</span>
      </div>

      <input
        type="range"
        className="stl-opacity-slider"
        min={OPACITY_MIN}
        max={OPACITY_MAX}
        step={1}
        value={opacity}
        onChange={(e) => setOpacity(Number(e.target.value))}
        aria-label="Model opacity percentage"
        style={{ "--stl-opacity-fill": opacityFill }}
      />

      <div className="stl-opacity-scale">
        <span>See-through</span>
        <span>Solid</span>
      </div>

      <button
        type="button"
        className="stl-opacity-reset"
        onClick={() => setOpacity(OPACITY_MAX)}
        disabled={opacity === OPACITY_MAX}
      >
        Reset to solid
      </button>
    </div>
  );
};

export default OpacityPanel;